import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";

// css
import "./poolPrepRoster.css"

// mui
import Tables from "components/table/table";

import poolPrepRosterAPI from "apis/panel/PoolPrepRoster/poolPrepRoster";
import Context from "context/context";
import leftarrow from "assets/images/arrow-right.png";
import Box from '@mui/material/Box';


import EditIcon from '@mui/icons-material/Edit';
import Modal from '@mui/material/Modal';

import 'react-calendar/dist/Calendar.css';
import moment from 'moment';
import { Button } from "../../../../../node_modules/@mui/material/index";

import EditPoolPrepRoster from "./EditPoolPrepRoster";


const PoolPrepRoster = () => {
  const { state, dispatch } = useContext(Context);
  const [roleCode] = useState(state.role.roleCode);
  const navigate = useNavigate();

  const { getAllPoolPrepRosterDetailsAPI } = poolPrepRosterAPI()

  const [poolPrepRosterDetails, setPoolPrepRosterDetails] = useState([])
  const [offset, setOffset] = useState(1);
  const [count, setCount] = useState(0);
  const [searchValue, setSearchValue] = useState("");
  const [filterValue, setFilterValue] = useState("");
  const [editId, setEditId] = useState('')
  const [open, setOpen] = useState(false);

  const [serialNumber, setSerialNumber] = useState("");


  const handleEdit = async (id) => {

    setOpen(true)

    setEditId(id) 
  }

  const handleNavigate = () => {
    navigate("/panel/addPoolPrepRoster")
  }

  const handleNavigation = () => {
    navigate("/panel/rpHomePage")
  }

  const handleClose = async () => {
    setEditId('')
    setOpen(false)
  }

  const handleGetAllPoolPrepRosterDetailsApi = async () => {


    try {
      dispatch({ type: "SET_LOADING", payload: true });
      let values;
      values = {
        offset: (offset - 1) * 20,
        limit: 20,
      };
      if (searchValue) {
        values = {
          ...values,
          searchValue,
        };
      }
      if (filterValue) {
        values = {
          ...values,
          filterValue,
        };
      }
      let res = await getAllPoolPrepRosterDetailsAPI(values);

      setPoolPrepRosterDetails(res?.data?.poolPrepRosters || []);
      setCount(res?.data?.count);
      setSerialNumber(offset)
      dispatch({ type: "SET_LOADING", payload: false });
    } catch (err) {
      dispatch({ type: "SET_LOADING", payload: false });
    }
  };


  useEffect(() => {

    handleGetAllPoolPrepRosterDetailsApi()

  }, [offset, searchValue, filterValue, open])

  

  return (
    <div
      className="vraShiftsMediaQuery"
      style={{
        backgroundColor: "white",
        borderRadius: "10px",
      }}
    >
      <Tables
        title={
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <div onClick={handleNavigation} style={{ cursor: 'pointer', paddingRight: 8 }}>
              <img src={leftarrow} alt="Back" />
            </div>
            <Box sx={{ pt: 2, pb: 2 }} className="VraShiftsTitle">
              Pool Prep Roster
            </Box>
          </div>
        }
        searchBar={true}
        filter={false}
        role={roleCode}
        create={

          <Button className="AddEmployerButton" onClick={handleNavigate}>
            Add
          </Button>
        }
        setSearchValue={setSearchValue}
        filterValue={filterValue}
        setFilterValue={setFilterValue}
        filterValues={[
          { label: "Region", value: "" },
          { label: "Practice", value: "practice" },
        ]}
        heading={[
          "S.No",
          "Region",
          "Practice",
          "RP Projection Date",
          "Initial/Soft Go-Live Date",
          "Status",
          "Modality 1",
          "Modality 1 Volume",
          "Full Go-Live Date",
          "Modality 2",
          "Modality 2 Volume",
          "Modality 3",
          "Modality 3 Volume",
          "No Of VRA Support Weekdays",
          "No Of VRA Support Weekends",
          "Coverage Duration",
          "Shift Pattern",
          "Handled By VRA",
          "Handled By RP",
          "Remarks",
          "Actions"

        ]}
        data={poolPrepRosterDetails?.map((e, index) => [

          index + 1 + (serialNumber - 1) * 20,

          e.region,
          e.practice,
          e.projection_date ? moment(e.projection_date).format('DD-MMM-YYYY') : e.projection_date,
          e.initial_soft_go_live_date ? moment(e.initial_soft_go_live_date).format('DD-MMM-YYYY') : e.initial_soft_go_live_date,
          e.status,
          e.modality1,
          e.modality1_volume,
          e.full_go_live_date ? moment(e.full_go_live_date).format('DD-MMM-YYYY') : e.full_go_live_date,
          e.modality2,
          e.modality2_volume,
          e.modality3,
          e.modality3_volume,
          e.no_of_vra_support_weekdays,
          e.no_of_vra_support_weekends,
          e.coverage_duration,
          e.shift_pattern,
          e.vra_fullname,
          e.handled_by_rp,
          e.remarks,
          <EditIcon style={{ color: "#FE6024", cursor: 'pointer' }} onClick={() => handleEdit(e.pool_prep_roster_id)} />,
        ])}
        offset={offset}
        setOffset={setOffset}
        limit={20}
        count={count}
        placeholder="Search by Region,Practice"
      />

      <Modal open={open} onClose={handleClose} aria-labelledby="modal-title"
        aria-describedby="modal-description" >
        <Box sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          height: 460,
          overflowY: 'scroll',
          transform: 'translate(-50%, -50%)',
          width: 800,
          bgcolor: 'background.paper',
          borderRadius: '10px',

          p: 4,
        }} >
          <EditPoolPrepRoster id={editId} onClose={handleClose} />
        </Box>
      </Modal>

    </div>
  )
}


export default PoolPrepRoster